var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import React, { useEffect, useState } from "react";
import RupeeBack from "@frameworks/shared-library/assets/images/features/Markets/NCD/rupee-back.svg";
export var useInitiateRefundDropDownTitle = function (isShowViewAll, setShowInitiateRefundPopup, subCategoryId, selectedValue) {
    switch (subCategoryId) {
        case ESubProductIds.StructuredProducts:
        case ESubProductIds.UnlistedShares:
        case ESubProductIds.Bonds:
        case ESubProductIds.NCD:
            var _a = __read(useState(false), 2), isExpanded_1 = _a[0], setExpanded_1 = _a[1];
            useEffect(function () {
                if (selectedValue) {
                    setExpanded_1(false);
                }
            }, [selectedValue]);
            return (!isShowViewAll && (React.createElement("div", { className: "d-flex align-items-center cursor-pointer position-relative otc-dropdown ".concat(selectedValue && "bg-cosmic-latte px-13 py-12 border-radius-10"), id: "initiate-refund", onClick: function () {
                    setExpanded_1(!isExpanded_1);
                    setShowInitiateRefundPopup(true);
                } },
                React.createElement("p", { className: "DMSanN_16_400 txt_cornflower-blue d-flex align-items-center" },
                    React.createElement("img", { src: RupeeBack, alt: "", className: "me-1" }),
                    " Initiate Refund",
                    selectedValue && ":",
                    React.createElement("u", null, selectedValue),
                    React.createElement("i", { className: " ".concat(isExpanded_1
                            ? "chevron edel-icon-arrow-up"
                            : "chevron edel-icon-arrow-down", " txt-hanBlue hand_cursor height-16 ms-1"), style: { lineHeight: "12px" } })))));
        default:
            return null;
    }
};
